export class CreateAlertSubscriptionDto {
  fleetId: number;
  alertDefinitionId: number;
  notifyByEmail: boolean;
  notifyBySms: boolean;
}
